import { type BaseApiContract } from "shared/api/apiRequestContractHandler";
import { HttpMethod } from "shared/api/http";
import { type CustomReportResults } from "shared/api/types/pagination";
import { type CustomReportBodyInput } from "shared/api/types/society/[societyId]/reports";
import {
  type SocietyReportInputParams,
  type CustomReportResponseType,
} from "shared/api/types/society/[societyId]/reports/[reportId]/index";
import { type CustomReportView } from "shared/mappers/database/reports/report";
export const getCustomReportIdContract: BaseApiContract<
  SocietyReportInputParams,
  undefined,
  CustomReportResults<CustomReportResponseType>
> = {
  method: HttpMethod.GET,
  apiRoute: "/api/v1/society/[societyId]/reports/[reportId]",
  paramsType: {} as SocietyReportInputParams,
  responseType: {} as CustomReportResults<CustomReportResponseType>,
};

export const postCustomReportIdContract: BaseApiContract<
  SocietyReportInputParams,
  CustomReportBodyInput,
  CustomReportView
> = {
  method: HttpMethod.POST,
  apiRoute: "/api/v1/society/[societyId]/reports/[reportId]",
  paramsType: {} as SocietyReportInputParams,
  bodyType: {} as CustomReportBodyInput,
  responseType: {} as CustomReportView,
};

export const deleteCustomReportIdContract: BaseApiContract<
  SocietyReportInputParams,
  undefined,
  void
> = {
  method: HttpMethod.DELETE,
  apiRoute: "/api/v1/society/[societyId]/reports/[reportId]",
  paramsType: {} as SocietyReportInputParams,
  bodyType: {} as unknown as undefined,
  responseType: {} as unknown as void,
};
